import React from 'react'
import ErrorModal from '../../../ErrorModal'
import { FormlessJourneyProps } from '../FormlessJourney'
import FormlessJourneyV3InterstitialWrapper from './Interstitial/FormlessJourneyV3InterstitialWrapper'
import withDetectRefresh from '../../../HOC/withDetectRefresh'

const FormlessJourneyV3Wrapper = ({
  experimentName,
  attribution,
  isPreapproved,
  lenderDetails,
  eventsServiceUrl,
  appFormEventParams,
  // injected props from HOC
  apiError,
  redirectUrl,
  closeError
}: FormlessJourneyProps): JSX.Element => {
  return (
    <>
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && attribution && (
        <FormlessJourneyV3InterstitialWrapper
          source={attribution.source}
          experimentName={experimentName}
          isPreapproved={isPreapproved}
          lenderDetails={lenderDetails}
          redirectUrl={redirectUrl}
          eventsServiceUrl={eventsServiceUrl}
          appFormEventParams={appFormEventParams}
        />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourneyV3Wrapper)
